// Mailjet Engagement → Lead workflow — frontend constants & node defaults.
// Extracted from ncrmWorkflows.mjs to keep that file within the size policy
// (see docs/engineering/modularity.md). Mirrors the backend defaults in
// backend/ncrm/workflows/workflow-defaults.js.

export const MAILJET_ENGAGEMENT_DEFAULT_WORKFLOW_INSTANCE_ID = "wf-mailjet-engagement-default";
export const MAILJET_LEAD_PRIORITIES = Object.freeze(["low", "normal", "high", "urgent"]);
export const MAILJET_TRIGGER_EVENT_TYPES = Object.freeze(["open", "click"]);

const DEFAULT_INTERVAL_MINUTES = 15;
const COMPATIBILITY_DEFAULT_PROMPT_KEY = "ncrm_mailjet_compatibility";
const COMPATIBILITY_DEFAULT_PROFILE_KEY = "enrich_research";

export const MAILJET_ENGAGEMENT_NODE_KEYS = Object.freeze({
  MAILJET_EVENT_TRIGGER: "mailjet-event-trigger",
  CONTACT_EXISTENCE_CHECK: "contact-existence-check",
  LEAD_PRESENCE_CHECK: "lead-presence-check",
  AI_COMPATIBILITY_CHECK: "ai-compatibility-check",
  MAILJET_LEAD_ADD: "mailjet-lead-add",
  TELEGRAM_NOTIFY: "telegram-notify",
});

export const createDefaultMailjetTriggerSettings = () => ({
  status: "active",
  description: "",
  accountId: null,
  eventTypes: [...MAILJET_TRIGGER_EVENT_TYPES],
  lookbackHours: 72,
  autoRun: false,
  autoRunIntervalMinutes: DEFAULT_INTERVAL_MINUTES,
});

export const createDefaultSimpleAutoRunSettings = () => ({
  status: "active",
  description: "",
  autoRun: false,
  autoRunIntervalMinutes: DEFAULT_INTERVAL_MINUTES,
});

export const createDefaultAiCompatibilitySettings = () => ({
  status: "inactive",
  description: "",
  mode: "manual",
  criterion: "",
  promptKey: COMPATIBILITY_DEFAULT_PROMPT_KEY,
  aiProfileKey: COMPATIBILITY_DEFAULT_PROFILE_KEY,
  autoRunIntervalMinutes: 60,
});

export const createDefaultMailjetLeadAddSettings = () => ({
  status: "active",
  description: "",
  autoRun: false,
  autoRunIntervalMinutes: DEFAULT_INTERVAL_MINUTES,
  boardId: null,
  stageId: null,
  priority: "high",
});

export const createDefaultTelegramNotifySettings = () => ({
  status: "inactive",
  description: "",
  telegram: {
    enabled: false,
    recipientUserIds: [],
  },
});

export const createMailjetEngagementNodeDefaults = () => ({
  [MAILJET_ENGAGEMENT_NODE_KEYS.MAILJET_EVENT_TRIGGER]: createDefaultMailjetTriggerSettings(),
  [MAILJET_ENGAGEMENT_NODE_KEYS.CONTACT_EXISTENCE_CHECK]: createDefaultSimpleAutoRunSettings(),
  [MAILJET_ENGAGEMENT_NODE_KEYS.LEAD_PRESENCE_CHECK]: createDefaultSimpleAutoRunSettings(),
  [MAILJET_ENGAGEMENT_NODE_KEYS.AI_COMPATIBILITY_CHECK]: createDefaultAiCompatibilitySettings(),
  [MAILJET_ENGAGEMENT_NODE_KEYS.MAILJET_LEAD_ADD]: createDefaultMailjetLeadAddSettings(),
  [MAILJET_ENGAGEMENT_NODE_KEYS.TELEGRAM_NOTIFY]: createDefaultTelegramNotifySettings(),
});
